import { FiImage } from "react-icons/fi"
import { ACCEPTED_IMAGE_EXTENSIONS_LIST, DEFAULT_IMAGE_MAX_FILE_SIZE_MB } from "./imageUtils"
import { cn } from "utils/helpers";

interface ImageUploadCardProps {
	children?: React.ReactNode;
	footer?: React.ReactNode;
	hasBorder?: boolean;
	hasImage?: boolean;
	showFileInfo?: boolean;
}

export const ImageUploadCard = ({ children, footer, hasBorder = true, hasImage = true, showFileInfo = true }: ImageUploadCardProps) => {
	return <div
		className={cn("flex h-full min-w-0 cursor-pointer items-center justify-center rounded-lg transition-colors"
			, hasBorder && "border-2 border-dashed p-4"
		)}
	>
		<div className="flex min-w-0 max-w-full flex-col items-center gap-1 text-gray-400 text-sm">
			{hasImage && <FiImage size={30} />}
			<div>{children}</div>
			{showFileInfo && <>
				{ACCEPTED_IMAGE_EXTENSIONS_LIST}
				<span className="text-xs">Max.{DEFAULT_IMAGE_MAX_FILE_SIZE_MB} MB per file </span>
			</>}
			<div>{footer}</div>
		</div>
	</div>
}